/*
* Copyright (c) 2009-2025. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

/**
 * Configuration settings for annotation loading performance optimization
 * Adjust these values based on your server capabilities and network conditions
 */

export default {
  // Maximum number of annotations to fetch per request
  // Set to 0 to disable pagination (if server doesn't support it)
  MAX_ANNOTATIONS_PER_REQUEST: 0, // Disabled by default for compatibility
  
  // Delay in milliseconds before loading annotations after pan/zoom stops
  DEBOUNCE_DELAY: 300,
  
  // Number of annotations above which clustering is automatically enabled
  CLUSTERING_THRESHOLD: 100,
  
  // Zoom level thresholds for progressive loading
  ZOOM_LEVELS: {
    // Below this zoom level, use aggressive clustering
    AGGRESSIVE_CLUSTERING: 10,
    
    // Above this zoom level, load full annotation details
    FULL_DETAILS: 14,
    
    // Above this zoom level, disable sorting for performance
    DISABLE_SORTING_THRESHOLD: 1000
  },
  
  // Style function cache settings
  STYLE_CACHE: {
    // Maximum number of cached styles before clearing
    MAX_SIZE: 10000
  },
  
  // API timeout settings (milliseconds)
  API_TIMEOUT: {
    // Default timeout for annotation requests
    DEFAULT: 30000,
    
    // Extended timeout for large annotation sets
    LARGE_SET: 60000
  },
  
  // Clustering settings
  CLUSTERING: {
    // Default k-means value for aggressive clustering
    // Set to null to disable (if server doesn't support kmeansValue parameter)
    AGGRESSIVE_KMEANS_VALUE: null
  },
  
  // Server compatibility settings
  SERVER_COMPATIBILITY: {
    // Whether the server supports the 'max' parameter for pagination
    SUPPORTS_MAX_PARAMETER: false,
    
    // Whether the server supports the 'kmeansValue' parameter
    SUPPORTS_KMEANS_VALUE: false,
    
    // Whether to use progressive loading (disabling WKT at low zoom)
    // Set to false if it causes issues
    USE_PROGRESSIVE_LOADING: false
  }
};